import ClusterMarker from './cluster-marker';
import geolib from 'geolib';
import {fitBounds} from 'google-map-react/utils';
import Map from 'google-map-react';
import mapStyles from './map-styles';
import Marker from './marker';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import supercluster from 'supercluster';

import './sold-map.scss';

const mapOptions = {
  scrollwheel: false,
  styles: mapStyles
};

class ListingsMap extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bounds: null,
      center: null,
      isInitializing: true,
      radius: 1, // in pixels
      zoom: 11 // default zoom
    }
  }

  getCenter = (coords) => {
    let center = geolib.getCenter(coords);
    try {
      center.latitude = parseFloat(center.latitude);
      center.longitude = parseFloat(center.longitude);
    } catch (e) {
      console.error(e);
      return false;
    }
    return center;
  }




  onChange = ({bounds, zoom}) => {
    //set max zoom to 16 to keep cluster marker for same location listings
    this.setState({zoom: zoom > 16 ? 16 : zoom, bounds: [bounds.sw.lng, bounds.sw.lat, bounds.ne.lng, bounds.ne.lat]});
  }

  getClusters = () => {
    const index = this.initializeClusters();
    return index.getClusters(this.state.bounds, this.state.zoom);
  }

  initializeClusters = () => {
    const coords = this.props.listings
      .filter(this.filterListings)
      .map(l => { 
        return {
          type: 'Feature',
          properties: {
            listingLink: l.listingLink,
            mapMarker: l.mapMarker,
            showPrice: l.showPrice
          },
          geometry: {
            type: 'Point',
            coordinates: l.location
          }
        }
      });
    const index = supercluster({
      maxZoom: 23,
      radius: this.state.radius
    });
    index.load(coords);
    return index;
  }

  filterListings = (l) => {
    return l.location && l.location.length > 1 && this.isProperLatLongValue(l.location[0]) && this.isProperLatLongValue(l.location[1]) && l.showMap;
  }

  isProperLatLongValue = (val) => val && val >= -180 && val <= 90;
  
  setInitialData = (props) => {
    const listings = props.listings.filter(this.filterListings);

  
    if (!props.showMap || !listings || (listings.length === 0)) {
      return;
    }

    const coords = listings.map(l => { return { latitude: l.location[1], longitude: l.location[0] }});
    const center = this.getCenter(coords);

    const boundsObj = geolib.getBounds(coords);
    const boundsArray = [boundsObj.minLng, boundsObj.minLat, boundsObj.maxLng, boundsObj.maxLat];

    const neswBounds = {
      ne: { lat: boundsObj.maxLat, lng: boundsObj.maxLng },
      sw: { lat: boundsObj.minLat, lng: boundsObj.minLng }
    };
    const size = { height: this._map.offsetHeight, width: this._map.offsetWidth };
    const { zoom } = fitBounds(neswBounds, size);
    
    this.setState({
      bounds: boundsArray,
      center: center,
      isInitializing: false,
      zoom: zoom > 11 ? 11 : zoom //do not zoom in more than 11
    });
  }

  componentDidMount() {
    this.setInitialData(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.setInitialData(nextProps);
  }

  getMarkers = (clusters) => {
    return clusters
      .map((cluster, index) => {
        if (cluster.properties.cluster) {
          return (
            <ClusterMarker
              lat={cluster.geometry.coordinates[1]}
              lng={cluster.geometry.coordinates[0]}
              numPoints={cluster.properties.point_count}
              key={index}
            />);
        } else {
          return (
            <Marker
              lat={cluster.geometry.coordinates[1]}
              lng={cluster.geometry.coordinates[0]}
              markerInfo={cluster.properties}
              key={index}
            />
          );
        }
      });
  }

  getMapBounds = (map, maps, places) => {
    const bounds = new maps.LatLngBounds();
  
    places.forEach((place) => {
      bounds.extend(new maps.LatLng(
        place.latitude,
        place.longitude
      )); 
    });
    return bounds;
  };

  apiIsLoaded = (map, maps) =>{
    const listings = this.props.listings.filter(this.filterListings);
    const places = listings.map(l => { return { latitude: l.location[1], longitude: l.location[0] }});
    const bounds = this.getMapBounds(map, maps, places);
    map.fitBounds(bounds)
  }

  render() {
    if (this.props.listings.filter(this.filterListings).length === 0) {
      return null;
    }
    let markers;
    if (!this.state.isInitializing) {
      const clusters = this.getClusters();
      markers = this.getMarkers(clusters);
    }

    return this.props.showMap ? (
      <div role="region" aria-label="map">
        <div className="sold-map" ref={node => this._map = node}>
          {markers ? <Map
            google={this.props.google}
            options={mapOptions}
            onChange={this.onChange}
            center={{ lat: this.state.center.latitude, lng: this.state.center.longitude }}
            zoom={this.state.zoom}
            resetBoundsOnResize={true}
            onGoogleApiLoaded={({ map, maps }) => this.apiIsLoaded(map, maps)}
            bootstrapURLKeys={{key: this.props.googleMapsKey}}>
            {markers}
          </Map> : null}
        </div>
      </div>
    ) : null;
  }
}

ListingsMap.propTypes = {
  listings: PropTypes.array.isRequired,
  showMap: PropTypes.bool.isRequired
};

export default ListingsMap;



// WEBPACK FOOTER //
// ./src/components/solds/sold-map/index.js